
// {a:true} => ?a=true
export const buildUrlQuery = (query) : any => {
    const q = Object.keys(query??{})
        .filter((k) => query[k] != null)
        .map((key) => key + "=" + encodeURIComponent(query[key]))
        .join("&")
    ;
    return q !== "" ? "?"+q : "";
};
